import React, {Component} from "react";

import axios from 'axios';
import history from '../../../history';
import Constants from '../../../components/Constants/';
import FileBase64 from 'react-file-base64';
import Select from 'react-select';

import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class ClientForm extends Component {

  constructor(props) {
    super(props);

    this.refreshClient = this.refreshClient.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);
    this.updateUserInputValue = this.updateUserInputValue.bind(this);
    this.updateCheckboxValue = this.updateCheckboxValue.bind(this);
    this.onImageSelect = this.onImageSelect.bind(this);

    this.onGroupSelect = this.onGroupSelect.bind(this);
    this.getClientGroupsStr = this.getClientGroupsStr.bind(this);
    this.saveClient = this.saveClient.bind(this);
    this.onVersionSelect = this.onVersionSelect.bind(this);

    this.state = {
        clientId: this.props.match.params.clientId,
        client: null,
        groupList: [],
        value: [],
        clientGroups: [],
        versionsList: [],
        desktopVersionIsMandatorySelected: null
    };
      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }
    }

    componentDidMount(){

      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/group'
      })
      .then(response => {

        let groupsList = [];
        response.data.forEach(function(group) {
          groupsList.push({
            value: group.id,
            label: group.name
          });
        });

        this.setState({groupList: groupsList});

      });

      axios({
        method: 'get',
        url: Constants.apiUrl+'/api/v1/desktop-version'
      })
      .then(response => {

        let versionsList = [];
        response.data.forEach(function(version) {
          versionsList.push({
            value: version.id,
            label: version.version + ' - ' + version.description
          });
        });

       this.setState({versionsList: versionsList});
      });

      this.refreshClient();
    }

    refreshClient(){

      if(this.props.match.params.clientId == null ){

        let blankClient = {
          id: null,
          code: "",
          name: "",
          phone: "",
          fax: "",
          email: "",
          enableEmergency: false,
          status: "ACTIVE",
          priority: "PRIORITY_NORMAL",
          reportLimit: 0,
          address: "",
          number: 0,
          complement: "",
          neighborhood: "",
          city: "",
          state: "",
          zipCode: "",
          orientation: "",
          logo: "",
          logoFileName: "",
          equipmentSerialNumber: "",
          equipmentType: "EQUIPMENT_TEB",
          accessPwd: "",
          tier: 'BRONZE',

          user: {
            userName: "",
            password: ""
          },
          fixedCostMonth: 0,
          numberExamsMonth: 0,
          extraExamCost: 0,
          urgentExamCost: 0,

          desktopVersion: null,
          desktopVersionIsMandatory: false

        };

        this.setState({
            client: blankClient
        });

      }else{
        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/client/'+this.props.match.params.clientId
        })
        .then(response => {
            if (response.data.tier == null || response.data.tier == "") {
              response.data.tier = 'BRONZE';
            }

            this.setState({
                client: response.data,
                desktopVersionIsMandatorySelected: response.data.desktopVersionIsMandatory != null ? response.data.desktopVersionIsMandatory.toString() : null
            });          
        });

        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/group/client/'+this.props.match.params.clientId
        })
        .then(response => {

          let actualClientGroups = [];
          response.data.forEach(function(group) {
            actualClientGroups.push(group.id);
          });

          this.setState({
              clientGroups: actualClientGroups
          });
        });
      }
    }

    saveClient(){
      let errorMessages = "";
      if(this.state.client.name == ""){
        errorMessages += "O campo Nome é obrigatório. \n";
      }
      if(this.state.client.equipmentType == ""){
        errorMessages += "O campo Tipo do Equipamento é obrigatório. \n";
      }
      if(this.state.client.user.userName == ""){
        errorMessages += "O campo Usuário é obrigatório. \n";
      }
      if(this.state.client.user.password == ""){
        errorMessages += "O campo Senha é obrigatório. \n";
      }
      if(this.state.client.desktopVersion != null && this.state.client.desktopVersionIsMandatory == null){
        errorMessages += "O campo 'Versão Obrigatória' deve ser informado. \n";
      }

      if(errorMessages != ""){
        this.msg.show(errorMessages, {
          time: 10000,
          type: 'success'
        });

        return false;
      }

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/client',
          data: this.state.client
      })
      .then(response => {
          history.replace("clients");
      });
    }

    updateInputValue(evt, input) {
      let actualClient = this.state.client;
      actualClient[input] = evt.target.value;

      this.setState({
        client: actualClient
      });
    }

    updateCheckboxValue(evt, input) {
      let actualClient = this.state.client;
      actualClient[input] = !actualClient[input];

      this.setState({
        client: actualClient
      });
    }

    updateUserInputValue(evt, input) {
      let actualClient = this.state.client;
      actualClient.user[input] = evt.target.value;

      this.setState({
        client: actualClient
      });
    }

    onImageSelect(file) {
      let actualClient = this.state.client;
	  let logo = file.base64.replace("data:image/jpeg;base64,", "").replace("data:image/JPEG;base64,", "").replace("data:image/png;base64,", "");
      actualClient.logo = logo;
      actualClient.logoFileName = file.name;
      this.setState({client: actualClient});
    }

    onGroupSelect (value) {
      let actualClientGroups = this.state.clientGroups;

      let tokens = value.split(',');

      //adicionar
      if(tokens.length > actualClientGroups.length){
        if(tokens[tokens.length-1] != "" && tokens[tokens.length-1] != undefined){
          actualClientGroups.push(tokens[tokens.length-1]);
          //Adiciona cliente ao Grupo

          axios({
              method: 'post',
              headers: {
                  'Content-Type': 'text/plain'
              },
              url: Constants.apiUrl+'/api/v1/group/addClient/'+tokens[tokens.length-1],
              data: this.state.client.id
          })
          .then(response => {
            this.msg.show("Grupo adicionado ao cliente.", {
              time: 10000,
              type: 'success'
            });
          });
        }
      }else if(tokens.length < actualClientGroups.length || (tokens.length == actualClientGroups.length && tokens[0] == "")){

        actualClientGroups.forEach(function(group) {
          if(tokens.indexOf(group) < 0){
            actualClientGroups.splice(actualClientGroups.indexOf(group), 1);
            //Remove médico do Grupo
            axios({
                method: 'delete',
                url: Constants.apiUrl+'/api/v1/group/removeClient/'+group+'/'+this.state.client.id
            })
            .then(response => {
              this.msg.show("Grupo removido deste cliente.", {
                time: 10000,
                type: 'success'
              });
            });
          }
        }, this);
      }

      this.setState({
        clientGroups: actualClientGroups
      });
  	}

    getClientGroupsStr(){
      let str = "";
      this.state.clientGroups.forEach(function(group) {
        if(str != ""){
          str += ","+group;
        }else{
          str += group;
        }
      });
      return str;
    }

    onVersionSelect(value) {
      let actualClient = this.state.client;
      let desktopVersionIsMandatorySelected = this.state.desktopVersionIsMandatorySelected;

      if(value != null){
        actualClient.desktopVersion = {id: value};
      } else {
        actualClient.desktopVersion = null;
        actualClient.desktopVersionIsMandatory = null;
        desktopVersionIsMandatorySelected = null;
      }
      
      this.setState({
        client: actualClient,
        desktopVersionIsMandatorySelected: desktopVersionIsMandatorySelected
      });
    }

    updateRadioValue(evt) {
      let actualClient = this.state.client;
      actualClient.desktopVersionIsMandatory = evt.target.value;
      
      this.setState({
        client: actualClient,
        desktopVersionIsMandatorySelected: evt.target.value
      });
    }   

    render() {
      if(this.state.client == null) return null;

      return(
          <div>
            <h2>Cliente</h2>
            <hr />

            <Row>
              <Col xs="6" md="6">
                  <Label>Nome</Label>
                  <Input type="text" id="name" ref="name" value={this.state.client.name}
                    onChange={evt => this.updateInputValue(evt, "name")} placeholder="Nome"/>
              </Col>

              <Col xs="6" md="6">
                <Label>Código</Label>
                <Input type="text" id="code" ref="name" value={this.state.client.code}
                  onChange={evt => this.updateInputValue(evt, "code")} placeholder="Código"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Telefone</Label>
                <Input type="text" id="phone" ref="phone" value={this.state.client.phone}
                  onChange={evt => this.updateInputValue(evt, "phone")} placeholder="Telefone"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Fax</Label>
                <Input type="text" id="fax" ref="fax" value={this.state.client.fax}
                  onChange={evt => this.updateInputValue(evt, "fax")} placeholder="Fax"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Email</Label>
                <Input type="text" id="email" ref="email" value={this.state.client.email}
                  onChange={evt => this.updateInputValue(evt, "email")} placeholder="Email"/>
              </Col>
            </Row>
            <hr />

            <Row>
              <Col xs="6" md="4">
                  <Label>Emergência</Label>
                  <br />
                  <Input type="checkbox" id="enableEmergency" value={!this.state.client.enableEmergency}
                    checked={!this.state.client.enableEmergency}
                    onChange={evt => this.updateCheckboxValue(evt, "enableEmergency")}/> Emergência
              </Col>

              <Col xs="6" md="4">
                <Label>Status</Label>

                <select className="form-control" onChange={evt => this.updateInputValue(evt, "status")} value={this.state.client.status}>
                  <option value="ACTIVE">Ativo</option>
                  <option value="INACTIVE">Inativo</option>
                </select>
              </Col>

              <Col xs="6" md="4">
                <Label>Prioridade</Label>

                <select className="form-control" onChange={evt => this.updateInputValue(evt, "priority")} value={this.state.client.priority}>
                  <option value="PRIORITY_LOW">Eletivo</option>
                  <option value="PRIORITY_NORMAL">Normal</option>
                  <option value="PRIORITY_HIGH">Urgente</option>
                  <option value="PRIORITY_URGENCY">Emerência</option>
                </select>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs="6" md="6">
                  <Label>Endereço</Label>
                  <Input type="text" id="address" ref="address" value={this.state.client.address}
                    onChange={evt => this.updateInputValue(evt, "address")} placeholder="Endereço"/>
              </Col>

              <Col xs="4" md="2">
                <Label>Número</Label>
                <Input type="text" id="number" ref="number" value={this.state.client.number}
                  onChange={evt => this.updateInputValue(evt, "number")} placeholder="Número"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Complemento</Label>
                <Input type="text" id="complement" ref="complement" value={this.state.client.complement}
                  onChange={evt => this.updateInputValue(evt, "complement")} placeholder="Complemento"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Bairro</Label>
                <Input type="text" id="neighborhood" ref="neighborhood" value={this.state.client.neighborhood}
                  onChange={evt => this.updateInputValue(evt, "neighborhood")} placeholder="Bairro"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Cidade</Label>
                <Input type="text" id="city" ref="city" value={this.state.client.city}
                  onChange={evt => this.updateInputValue(evt, "city")} placeholder="Cidade"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Estado</Label>
                <Input type="text" id="state" ref="state" value={this.state.client.state}
                  onChange={evt => this.updateInputValue(evt, "state")} placeholder="Estado"/>
              </Col>

              <Col xs="6" md="4">
              <Label>CEP</Label>
                <Input type="text" id="zipCode" ref="zipCode" value={this.state.client.zipCode}
                  onChange={evt => this.updateInputValue(evt, "zipCode")} placeholder="CEP"/>
              </Col>


            </Row>

            <hr />
            <Label>Logo</Label>
            <br />
            {
              this.state.client.logo ?
              <img src={"data:image/JPEG;base64,"+this.state.client.logo} className="img img-responsive" />
              : null
            }
            {'\u00A0'}{'\u00A0'}
            <FileBase64
              multiple={ false }
              onDone={ this.onImageSelect } />

            <hr />

            <Row>
              <Col xs="6" md="4">
                <Label>Equip. S/N</Label>
                <Input type="text" id="equipmentSerialNumber" ref="equipmentSerialNumber" value={this.state.client.equipmentSerialNumber}
                  onChange={evt => this.updateInputValue(evt, "equipmentSerialNumber")} placeholder="Eq. SN"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Tipo Equip.</Label>

                <select className="form-control" onChange={evt => this.updateInputValue(evt, "equipmentType")} value={this.state.client.equipmentType}>
                  <option value=""></option>
                  <option value="EQUIPMENT_AEROTEL">AEROTEL</option>
                  <option value="EQUIPMENT_EPEOPLE">EPEOPLE</option>
                  <option value="EQUIPMENT_TEB">TEB</option>
                  <option value="EQUIPMENT_CARDIOWEB_SERVER">CARDIOWEB SERVIDOR</option>
                  <option value="EQUIPMENT_CARDIOWEB_CLIENT">CARDIOWEB CLIENTE</option>
                  <option value="EQUIPMENT_CARDIOWEB_MEDIANA">CARDIOWEB MEDIANA</option>
                  <option value="EQUIPMENT_PHYSIO_GLOVE">PHYSIO GLOVE</option>
                  <option value="EQUIPMENT_MICROMED_600">MICROMED 600</option>
                  <option value="EQUIPMENT_MICROMED_300">MICROMED 300</option>
                  <option value="EQUIPMENT_VENTRIX">VENTRIX</option>
				          <option value="EQUIPMENT_BIONET_CARDIOXP">BIONET CARDIOXP</option>
				  <option value="EQUIPMENT_HW">HW 1200</option>

                </select>
              </Col>
            </Row>
`
            <Row>
              <Col xs="6" md="4">
                <Label>Valor Contrato Mensal</Label>
                <Input type="number" id="fixedCostMonth" ref="fixedCostMonth" value={this.state.client.fixedCostMonth}
                  onChange={evt => this.updateInputValue(evt, "fixedCostMonth")} placeholder="Valor Contrato Mensal"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Cota Exames/Mês</Label>
                <Input type="number" id="numberExamsMonth" ref="numberExamsMonth" value={this.state.client.numberExamsMonth}
                  onChange={evt => this.updateInputValue(evt, "numberExamsMonth")} placeholder="Cota Exames/Mês"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Valor por Exame Extra</Label>
                <Input type="number" id="extraExamCost" ref="extraExamCost" value={this.state.client.extraExamCost}
                  onChange={evt => this.updateInputValue(evt, "extraExamCost")} placeholder="Valor por Exame Extra"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Valor por Exame Urgente</Label>
                <Input type="number" id="urgentExamCost" ref="urgentExamCost" value={this.state.client.urgentExamCost}
                  onChange={evt => this.updateInputValue(evt, "urgentExamCost")} placeholder="Valor por Exame Urgente"/>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs="6" md="4">
                <Label>Usuário</Label>
                <Input type="text" id="username" ref="username" value={this.state.client.user.userName}
                  onChange={evt => this.updateUserInputValue(evt, "userName")} placeholder="Usuário"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Senha</Label>
                <Input type="password" id="password" ref="password" value={this.state.client.user.password}
                  onChange={evt => this.updateUserInputValue(evt, "password")} placeholder="Senha"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Cód. Acesso</Label>
                <Input type="text" id="accessPwd" ref="accessPwd" value={this.state.client.accessPwd}
                  onChange={evt => this.updateInputValue(evt, "accessPwd")} placeholder="Cód. Acesso"/>
              </Col>

              <Col xs="6" md="6">
                <Label>Orientação</Label>
                <Input type="textarea" id="orientation" ref="orientation" value={this.state.client.orientation}
                  onChange={evt => this.updateInputValue(evt, "orientation")} placeholder="Orientação"/>
              </Col>
            </Row>

            <div className={this.props.match.params.clientId == null ? "hidden" : ""}>
              <hr />
              <Label>Grupos</Label>
              <br />
              <Select
                closeOnSelect={false}
                multi
                onChange={this.onGroupSelect}
                options={this.state.groupList}
                placeholder="Grupos"
                removeSelected={true}
                simpleValue
                value={this.getClientGroupsStr()}
              />
              <br />
            </div>

            <hr />

            <Row>
              <Col xs="6" md="4">
                <Label>Tier</Label>

                <select className="form-control" onChange={evt => this.updateInputValue(evt, "tier")} value={this.state.client.tier}>                  
                  <option value="GOLD">Ouro</option>
                  <option value="SILVER">Prata</option>
                  <option value="BRONZE">Bronze</option>
                </select>
              </Col>
              <Col xs="6" md="4">
                <Label>Versão</Label>
                <Select 
                  name="version"
                  closeOnSelect={true}
                  options={this.state.versionsList}
                  placeholder="Versão"
                  simpleValue
                  clearable={true}
                  openOnClick={true}
                  searchable={true}
    					    value={this.state.client.desktopVersion == null ? '' : this.state.client.desktopVersion.id}
                  onChange={this.onVersionSelect}
                />
              </Col>
              <Col xs="6" md="4">
                <Label>Versão Obrigatória</Label>
                  <br />
                  <Input type="radio" value="true" checked={this.state.desktopVersionIsMandatorySelected === "true"} onChange={evt => this.updateRadioValue(evt)}/> Sim
                  <Input type="radio" value="false" checked={this.state.desktopVersionIsMandatorySelected === "false"} onChange={evt => this.updateRadioValue(evt)} className="margin-custom"/> Não
              </Col>
            </Row>

            <br />
            <Button color="success" onClick={() => { this.saveClient(); }}>Salvar Cliente</Button>
            <br />
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default ClientForm;



// WEBPACK FOOTER //
// ./src/views/admin/ClientForm/ClientForm.js